import {RouteObject, RouterContextProvider, redirect} from 'react-router';

import {EFeatureFlag, userEndpoints} from 'src/containers/User';
import {getDispatch} from 'src/routerContext';

import {ESupportTabs} from './definitions';

const checkVerificationAccess = async (context: RouterContextProvider) => {
  const dispatch = getDispatch(context);
  const {data: featureFlags} = await dispatch(userEndpoints.getFeatureFlags.initiate());

  return !!featureFlags?.[EFeatureFlag.WHATSAPP_PARTNER_VERIFICATION];
};

const children: RouteObject[] = [
  {
    index: true,
    loader: () => redirect(ESupportTabs.CLIENTS),
  },
  {
    path: ESupportTabs.CLIENTS,
    lazy: async () => ({
      Component: (await import('src/containers/SupportClients')).default,
    }),
  },
  {
    path: ESupportTabs.VERIFICATIONS,
    loader: async ({context}) => {
      const hasAccess = await checkVerificationAccess(context);

      if (!hasAccess) {
        throw redirect(`../${ESupportTabs.CLIENTS}`);
      }
    },
    lazy: async () => ({
      Component: (await import('src/containers/SupportVerifications')).default,
    }),
  },
];

export const supportRoutes: RouteObject = {
  loader: async ({context}) => {
    const availableTabs: ESupportTabs[] = [ESupportTabs.CLIENTS];
    const hasVerificationAccess = await checkVerificationAccess(context);

    if (hasVerificationAccess) {
      availableTabs.push(ESupportTabs.VERIFICATIONS);
    }

    return {
      tabs: availableTabs,
    };
  },
  children,
};
